import { Component, Input ,PLATFORM_ID ,Inject,ElementRef, ViewChild, ChangeDetectorRef,NgZone} from '@angular/core';
import { CommonModule,isPlatformBrowser  } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { BaseChartDirective } from 'ng2-charts'; 
import { ChartConfiguration, ChartData } from 'chart.js';

import { AnalysisOptionsComponent } from '../../../tools/analysis-options/analysis-options.component';
import { FacadeService } from '../../../services/facade.service';
import { ProyectosService } from '../../../services/proyectos.service';
import { AnalysisServiceService } from '../../../services/analysis-service/analysis-service.service';

//Variables del Navegador
type MenuItem = 'wl' | 'wc';

//Variable para expandir cada cuadro
interface ExpandedState {
  [key: string]: boolean;
}

interface WordCount {
  word: string;
  count: number;
}

interface Data {
  [key: string]: WordCount[];
}

interface DividedData {
  [key: string]: WordCount[][];
}


@Component({
  selector: 'evp',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    AnalysisOptionsComponent,
    BaseChartDirective,
    HttpClientModule,
    FormsModule],
  templateUrl: './evp.component.html',
  styleUrls: ['./evp.component.css'],
})
export class EvpComponent {
  respuestaWords: any[] = [];
  selectedMenuItem: MenuItem = 'wl';
  @Input() checked: boolean; //Variable del mat-slide-toggle del text-component

  selectAllActive = false;

  verifyLoaderActive2: boolean;

  loaderActive: boolean;
  loaderActive2: boolean;
  loaderActiveFirstProject: boolean;

  imgSrc: { [key: string]: string } = {};
  currentEnglishType = "";
  currentEnglishType2 = "";

  isIconRotated = false;
  
  isScreenLarge: boolean = false;

  short_words:boolean;

  UpdateEVP:boolean = false;
  matchPrhases: boolean = false;
  isUpdatingMatchPhrases: boolean = false;

  public dividedData = {};
  project_data: any;
  public ishighlighted = {};
  palabraresaltada = {};
  public pof = {}
  public data_pof = {};
  public data_pof2 = {};
  public data_pof3 = {};
  public cambios_de_palabras: any = []

  public hideEyeIconsForSafari1561 = false;

  public isKnownWordsCategory(name: string): boolean {
    return (name || '').replace(/\s+/g, '').toUpperCase() === 'KNOWNWORDS';
  }

  public getKnownWordsLabel(name: string): string {
    return this.isKnownWordsCategory(name) ? 'Known Words' : (name || '');
  }


  //Valores para expandir cada Cuadro
  public isExpanded = {};
  public encabezados = {}

  ngOnInit(): void {
    localStorage.setItem("actual","evp")
     document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible" && this.evpDataReady) {
          this.cdr.detectChanges();
        }
      });

    this.isButtonDisabled();
    this.hideEyeIconsForSafari1561 = false;
    if (isPlatformBrowser(this.platformId)) {
      this.isScreenLarge = window.innerWidth > 1000;
      window.addEventListener('resize', this.onResize.bind(this));
    }
    this.initSubscribe()
     if(sessionStorage.getItem("id_project")){
    this.initEVP()
     }
    this.analysisService.currentEnglishType.subscribe(mode => {
      this.currentEnglishType = mode;
    });

     this.analysisService.currentEnglishType.subscribe(mode => {
      if(mode === "american"){
        this.currentEnglishType2 = "American English";
      }
      else{
        this.currentEnglishType2 = "British English";
      }
      
    });
    if(sessionStorage.getItem("text_UID")){
      this.loaderActive = true;
    }
     this.proyectoService.loader$.subscribe(loader => {
      if(this.loaderActive2){
        this.loaderActive = false;
      }else{
        this.loaderActive = loader;
      }
    });
    
        this.proyectoService.loaderAnalyzing$.subscribe(loader => {
      if(loader){
        this.loaderActive2 = true;
      }
      if(!loader){
        this.loaderActive2 = false;
      }
    });
         this.proyectoService.loaderCreatingProject$.subscribe(value => {
      if(value){
        this.loaderActive2 = true;
      }
      if(!value){
        this.loaderActive2 = false;
      }
    });
    // **Inicializar correctamente el estado de los ojos**
    Object.keys(this.data_pof3).forEach(categoria => {
      this.isEyeOn[categoria] = false; // Todas inician apagadas
    });

    this.categoriasActivas.clear(); // Limpiar selección inicial

   // **Inicializar correctamente el estado de los ojos**
    Object.keys(this.data_pof3).forEach(categoria => {
        this.isEyeOn[categoria] = false; // Todas las categorías inician apagadas
    });

    this.categoriasActivas.clear(); // Limpiar selección inicial

    // **Forzar "See All" a estar apagado al inicio**
    this.seeAllActive = false;
    this.seeAllIconSrc = '../../assets/images/eye-icon.svg';

        this.proyectoService.verifyloaderAnalyzing$.subscribe(value => {
      if(value){
        this.verifyLoaderActive2 = true;
      }
      if(!value){
        this.verifyLoaderActive2 = false;
      }
    });

  }

  public isSafariVersion1561(): boolean {
    const ua = navigator.userAgent;
    const safariMatch = ua.match(/Version\/([\d.]+) Safari\//);
    const isSafari = ua.includes("Safari") && ua.includes("Macintosh") && !ua.includes("Chrome");

    if (safariMatch && safariMatch[1] && isSafari) {
      return safariMatch[1] === "15.6.1";
    }

    return false;
  }

  public evp = {
    too_short_error:false
  }

  public data: Data = {
  };

  ngOnDestroy(): void {
    this.proyectoSub?.unsubscribe();
  }

  initSubscribe() {
    if (!this.proyectoSub || this.proyectoSub.closed) {
      //Subscribimos al servicio para escuchar los datos
      this.proyectoSub = this.proyectoService.proyecto$.subscribe(({ proyecto, firstProject })=>{
         if(!firstProject){
            this.loaderActive = false;
            if(sessionStorage.getItem("text_UID")){
              if(!this.loaderActiveFirstProject){
              this.loaderActive2 = true;
            }
            }else{
              this.loaderActive2 = false;
            }
          }
          if(firstProject){
            this.loaderActive = false;
            if(sessionStorage.getItem("text_UID")){
              this.loaderActiveFirstProject = true;
            }else{
              this.loaderActiveFirstProject = false;
            }
          }
        console.log("Update de data --Reporta: EVP--")
        this.project_data = proyecto;
        this.matchPrhases = proyecto?.config_json?.matchPrhases ?? false;
  
         // Apagar todas las palabras resaltadas
        Object.keys(this.palabraresaltada).forEach(categoria => {
          Object.keys(this.palabraresaltada[categoria]).forEach(palabra => {
              this.palabraresaltada[categoria][palabra] = false;
          });
        });
  
        // Apagar todos los ojos de verPalabra
        Object.keys(this.palabraSeleccionada).forEach(key => {
          this.palabraSeleccionada[key] = false;
        });
  
         // **Apagar todas las palabras resaltadas activadas por toggleEyeIconPalabra**
        Object.keys(this.palabraresaltada).forEach(categoria => {
          Object.keys(this.palabraresaltada[categoria]).forEach(palabraResaltada => {
            this.palabraresaltada[categoria][palabraResaltada] = false;
          });
        });
  
        // Apagar ojos
        Object.keys(this.isEyeOn).forEach(categoria => {
          this.isEyeOn[categoria] = false;
        });
  
        this.categoriasActivas.clear();
        this.seeAllActive = false;
        this.seeAllIconSrc = '../../assets/images/eye-icon.svg';
  
        this.proyectoService.undoMarcadoMultiple(this.http);
        
        if(sessionStorage.getItem("id_project")){
        this.initEVP();
        }
      });
    }
  }

divideData() {
  for (const key in this.data_pof) {
    if (this.data_pof.hasOwnProperty(key)) {
      const items = Object.keys(this.data_pof[key]);
        const chunkSize = Math.ceil(items.length / 3);
      this.dividedData[key] = [
          items.slice(0, chunkSize),
          items.slice(chunkSize, chunkSize * 2),
          items.slice(chunkSize * 2),
      ];
    }
  }
}

tempEmpty: any = {};


  onResize() {
    this.isScreenLarge = window.innerWidth > 1000;
  }

  toggleIcon() { 
    this.isIconRotated = !this.isIconRotated; 
  }

  resetIcon() { this.isIconRotated = false; }

  async onMatchPhrasesChange(event: any): Promise<void> {
    const previousValue = this.matchPrhases;
    const idProject = sessionStorage.getItem('id_project');

    if (!idProject) {
      this.matchPrhases = previousValue;
      return;
    }

    this.matchPrhases = event.checked;
    this.isUpdatingMatchPhrases = true;

    const currentProject = this.project_data || this.proyectoService.getdata();
    const data = {
      id_project: idProject,
      config_json: {
        ...(currentProject?.config_json || {}),
        matchPrhases: this.matchPrhases,
      },
    };

    try {
      const response = await this.fachada.UpdateNameofProyect(this.http, data);
      await this.proyectoService.updateData(response);
      this.proyectoService.updateEditEye(false);
      this.proyectoService.terminarEdicionErrores(this.http);
      this.proyectoService.showEditEye(false);
      this.proyectoService.undoMarcadoMultiple(this.http);
    } catch (error) {
      this.matchPrhases = previousValue;
      console.error('No se pudo actualizar matchPrhases.', error);
    } finally {
      this.isUpdatingMatchPhrases = false;
    }
  }

  private proyectoSub;
  

  constructor(
    private http: HttpClient,
    public fachada: FacadeService,
    public proyectoService: ProyectosService,
    private analysisService: AnalysisServiceService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object
    ) {
    this.checked = true;
  }

  status: any;
  evpDataReady = false;

  async initEVP() {
     let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "evp"){
      // Intentar recuperar el resumen desde sessionStorage
      const memoryStorage = sessionStorage.getItem("evp");
  
      if (memoryStorage && !this.UpdateEVP) {
         if(memoryStorage !== "-"){
        try {
          let respuesta = JSON.parse(memoryStorage);
  
            // Asignar los encabezados
            this.encabezados = respuesta.encabezados;
            this.evp = respuesta;
            this.short_words = this.evp.too_short_error;
  
            // Separar 'count' y 'description' directamente
            this.data_pof = {};
            this.data_pof2 = {};
            for (const key in respuesta.taggeddata) {
                this.data_pof[key] = {};
                this.data_pof2[key] = {};
                this.data_pof3[key] = {};
                for (const palabra in respuesta.taggeddata[key]) {
                    this.data_pof[key][palabra] = respuesta.taggeddata[key][palabra].count;
                    this.data_pof2[key][palabra] = respuesta.taggeddata[key][palabra].description;
                    this.data_pof3[key][palabra] = respuesta.taggeddata[key][palabra].position;
  
                }
            }
  
            this.changecharData();
  
            // Inicializamos el objeto Is expanded para que coincida con lo que trae el middleware
            for (const key in this.encabezados) {
                this.isExpanded[key] = this.isExpanded[key] ?? false;
                this.ishighlighted[key] = this.ishighlighted[key] ?? false;
                const keyUpper = key.toUpperCase();
                const previousWordHighlights = this.palabraresaltada[keyUpper] ?? {};
                this.palabraresaltada[keyUpper] = {};
                for (const palabra in this.data_pof[keyUpper]) {
                  this.palabraresaltada[keyUpper][palabra] = previousWordHighlights[palabra] ?? false;
                }
  
            }
            this.evpDataReady = true;

        } catch (error) {
            console.log("Error en la petición de datos");
            console.log(error);
            sessionStorage.removeItem('evp');
        }finally{
          this.loaderActive2 = false;
          this.loaderActive = false;
          this.loaderActiveFirstProject = false;
          this.proyectoService.updateloader(false);
          this.zone.run(() => this.cdr.detectChanges());

        }
      }
      }
      if(!memoryStorage || this.UpdateEVP){
        sessionStorage.setItem("evp", "-");
        // Tenemos que esperar unos milisegundos en lo que el servicio actualiza la información
        await new Promise(resolve => setTimeout(resolve, 10));
        try {
          let textUID = sessionStorage.getItem('text_UID');
            let respuesta = await this.fachada.getLexicalEVPOfProject(this.http,textUID, "");
            // Guardar la respuesta en sessionStorage
            sessionStorage.setItem("evp", JSON.stringify(respuesta));
  
            // Asignar los encabezados
            this.encabezados = respuesta.encabezados;
            this.evp = respuesta;
            this.short_words = this.evp.too_short_error;
  
            // Separar 'count' y 'description' directamente
            this.data_pof = {};
            this.data_pof2 = {};
            for (const key in respuesta.taggeddata) {
                this.data_pof[key] = {};
                this.data_pof2[key] = {};
                this.data_pof3[key] = {};
                for (const palabra in respuesta.taggeddata[key]) {
                    this.data_pof[key][palabra] = respuesta.taggeddata[key][palabra].count;
                    this.data_pof2[key][palabra] = respuesta.taggeddata[key][palabra].description;
                    this.data_pof3[key][palabra] = respuesta.taggeddata[key][palabra].position;
  
                }
            }
  
            this.changecharData();
  
            // Inicializamos el objeto Is expanded para que coincida con lo que trae el middleware
            for (const key in this.encabezados) {
                this.isExpanded[key] = this.isExpanded[key] ?? false;
                this.ishighlighted[key] = this.ishighlighted[key] ?? false;
                const keyUpper = key.toUpperCase();
                const previousWordHighlights = this.palabraresaltada[keyUpper] ?? {};
                this.palabraresaltada[keyUpper] = {};
                for (const palabra in this.data_pof[keyUpper]) {
                  this.palabraresaltada[keyUpper][palabra] = previousWordHighlights[palabra] ?? false;
                }
  
            }
            this.status = 200
            this.cdr.detectChanges();
            this.evpDataReady = true;


        } catch (error) {
             if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (evp)");
            sessionStorage.removeItem('evp');
            this.status = 0

          } else {
            console.log("Otro error en la petición de datos")
            console.log(error)
            sessionStorage.removeItem('evp');
          }
          this.status = error?.status;
        }finally{
          if(this.status === 0){
             this.loaderActive2 = true;
            this.loaderActive = true;
            this.loaderActiveFirstProject = true;
            this.proyectoService.updateloader(true);
            this.UpdateEVP = true;
             setTimeout(() => {
              this.initEVP();
            }, 100);
          }
          else{ 
            this.loaderActive2 = false;
            this.loaderActive = false;
            this.loaderActiveFirstProject = false;
            this.proyectoService.updateloader(false);
            this.UpdateEVP = false;
            this.zone.run(() => this.cdr.detectChanges());
          }
         
         
        }
      }
        }else{
      console.log(`evp no es la pantalla actual así que bloqueamos peticiones`)
    }

    this.divideData();
  }
  palabraSeleccionada: { [key: string]: boolean } = {};

  verPalabra(palabra: string, categoria: string, index: number, desdeOjo: boolean = true): void {
    const categoriaUpper = categoria.toUpperCase();
    const key = `${categoriaUpper}-${palabra}-${index}`;

    // Apagar todos los ojos activados por toggleEyeIcon
    Object.keys(this.isEyeOn).forEach(categoria => {
      this.isEyeOn[categoria] = false;
    });
    this.categoriasActivas.clear();
    this.seeAllActive = false;
    this.seeAllIconSrc = '../../assets/images/eye-icon.svg';


    // Verificar si la categoría existe
    if (!this.data_pof3[categoriaUpper]) {
      console.error(`No se encontró la categoría "${categoriaUpper}".`);

      return;
    }

    // Verificar si la palabra existe dentro de la categoría
    const palabraData = this.data_pof3[categoriaUpper]?.[palabra];

    if (!palabraData || !Array.isArray(palabraData) || palabraData.length === 0) {
      console.error(`No se encontró la palabra "${palabra}" en la categoría "${categoriaUpper}" o no tiene posiciones válidas.`);

      return;
    }

  

    // Si el ojo está encendido y lo presionas, se apaga
    if (desdeOjo && this.palabraSeleccionada[key]) {
      this.palabraSeleccionada[key] = false;

      this.proyectoService.undoMarcadoMultiple(this.http);
      return;
    }

    // **Apagar todas las palabras resaltadas activadas por toggleEyeIconPalabra**
    Object.keys(this.palabraresaltada).forEach(categoria => {
      Object.keys(this.palabraresaltada[categoria]).forEach(palabraResaltada => {
        this.palabraresaltada[categoria][palabraResaltada] = false;
      });
    });

    // Primero apagamos todas las palabras antes de encender una nueva (excepto si es el mismo ojo)
    Object.keys(this.palabraSeleccionada).forEach(k => {
      this.palabraSeleccionada[k] = false;
    });

    // Encender la palabra seleccionada
    this.palabraSeleccionada[key] = true;

    // Recopilar posiciones de la palabra en la categoría seleccionada
    const posicionesSeleccionadas: { posicion: number; categoria: string }[] = palabraData.map(pos => ({
      posicion: pos,
      categoria: categoriaUpper
    }));

  

    // Verificar que el índice solicitado es válido
    if (index < 0 || index >= posicionesSeleccionadas.length) {
      console.error(`Índice fuera de rango: ${index}`);
      return;
    }

    // Obtener la posición específica de la palabra seleccionada en la categoría
    const posicionSeleccionada = posicionesSeleccionadas[index].posicion;


    // Recopilar posiciones de todas las categorías
    const posicionesOtrasCategorias: { posicion: number; categoria: string }[] = [];
    Object.keys(this.data_pof3).forEach(key => {
      if (key !== categoriaUpper) {
        const palabraEnCategoria = this.data_pof3[key]?.[palabra];
        if (palabraEnCategoria && Array.isArray(palabraEnCategoria) && palabraEnCategoria.length > 0) {
          palabraEnCategoria.forEach(pos => {
            posicionesOtrasCategorias.push({ posicion: pos, categoria: key });
          });
        }
      }
    });



    // Combinar todas las posiciones
    const todasLasPosiciones = [...posicionesSeleccionadas, ...posicionesOtrasCategorias];

    // Ordenar todas las posiciones de menor a mayor
    todasLasPosiciones.sort((a, b) => a.posicion - b.posicion);



    // Determinar el orden de la palabra seleccionada en el texto
    const ordenSeleccionado = todasLasPosiciones.findIndex(
      posObj => posObj.categoria === categoriaUpper && posObj.posicion === posicionSeleccionada
    );

    if (ordenSeleccionado !== -1) {


      this.proyectoService.resaltarCoincidenciaOrdenada(
        palabra,
        categoriaUpper,
        todasLasPosiciones,
        ordenSeleccionado + 1, // Empieza en 1
        this.http
      );
    } else {
      console.log(`No se encontró orden válido para la posición ${posicionSeleccionada} en la categoría "${categoriaUpper}".`);
    }
  }




  changecharData(){
    let colores = [];
    // let labels = [];
    let dataset = {
      data:[],
      label: 'Types (Unique tokens)',
      backgroundColor: [],
      // Hace las barras más delgadas
      barThickness: 40,
    }
    this.barChartData.labels = [];
    let maxValue = 0;
    for (const item of Object.keys(this.encabezados)) {
      if (this.encabezados[item].Name != "UNLISTED"){
        this.barChartData.labels.push(this.encabezados[item].Name);
        dataset.backgroundColor.push(this.traducirColor(this.encabezados[item].Name));
        dataset.data.push(this.encabezados[item].unique_words);
      }
    }
    // console.log(dataset)
    this.barChartData.datasets = [dataset]
  }

  //Funcion para expandir cada cuadro
  toggleExpand(identifier: string) {
    this.isExpanded[identifier] = !this.isExpanded[identifier];
  }
  
  toggleExpandAll() {
    // Verificar si todos los valores son true
    const allExpanded = Object.keys(this.isExpanded).every(key => {
        const formattedKey = key.toLowerCase() === 'unlisted' ? 'UNLISTED' : key.toUpperCase();
        return this.isExpanded[formattedKey];
    });
    
    // Crear una copia de las claves para iterar
    const keys = Object.keys(this.isExpanded);

    // Modificar los valores respetando el formato de las claves
    keys.forEach(key => {
        const formattedKey = key.toLowerCase() === 'unlisted' ? 'UNLISTED' : key.toUpperCase();
        this.isExpanded[formattedKey] = !allExpanded;
    });

    // Actualizar showAll después de realizar los cambios
    this.showAll = allExpanded;
}


showAll: boolean = true;



  getObjectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  traducirColor(cefr){
    switch (cefr){
      case "A1":
        return "#F66B2D"
      case "A2":
        return "#24908E"
      case "B1":
        return "#F41425"
      case "B2":
        return "#1C6C34"
      case "C1":
        return "#2C51F5"
      case "C2":
        return "#8A268C"
      case "Unlisted":
        return "transparent"
      default:
        return "#2A3654"
    }
  }

  selectMenuItem(menuItem: MenuItem) {
    this.selectedMenuItem = menuItem;
  }

  isSelected(menuItem: MenuItem): boolean {
    return this.selectedMenuItem === menuItem;
  }
  
  //Variables Pagina 2 WordCharts
  public barChartOptions: ChartConfiguration<'bar'>['options'] = {
    scales: {
      x: {
        grid: {
          display: false,  // Ocultar las líneas verticales
        },
      },
      y: {
        min: 0,
        max: 50,  // Límite máximo del eje Y en 50
        ticks: {
          stepSize: 10,  // Incrementos de 10 en 10
        },
        border: {
          display: false  // Eliminar el borde del eje Y
        },
        grid: {
          color: '#E0E0E0',  // Color de las líneas horizontales
        },
      },
    },
    plugins: {
      legend: {
        display: false, // Ocultar la leyenda
      },
      datalabels: {
              display: false // Desactiva los datalabels solo en este gráfico
      },
    },
  };
  
  
  public barChartType = 'bar' as const;
  
  public barChartData: ChartData<'bar'> = {
    labels: [],
    datasets: [
      { 
        data: [],
        label: '',
        backgroundColor: [
          '#FF5722',  // Naranja
          '#009688',  // Verde
          '#F44336',  // Rojo
          '#4CAF50',  // Verde claro
          '#3F51B5',  // Azul
          '#9C27B0',  // Púrpura
        ],
        // Hace las barras más delgadas
        barThickness: 40,
      },
    ],
  };
  ponerOjo(event: MouseEvent, categoria: string, palabra: string): void {
    const element = event.currentTarget as HTMLElement;
  
    // Cambiar el fondo del contenedor
    element.style.background = "#FAE29E";
  
    // Mostrar los íconos
    const eyeIcons = element.querySelectorAll('.icon-eye');
    const projectIcon = element.querySelector('.icon-project');
  
    eyeIcons.forEach((icon) => {
      (icon as HTMLElement).style.visibility = "visible";
    });
  
    if (projectIcon) {
      (projectIcon as HTMLElement).style.visibility = "visible";
    }
  }
  
  quitarOjo(event: MouseEvent, categoria: string, palabra: string): void {
    const element = event.currentTarget as HTMLElement;
  
    // Restaurar el fondo del contenedor
    element.style.background = "transparent";
  
    // Ocultar los íconos
    const eyeIcons = element.querySelectorAll('.icon-eye');
    const projectIcon = element.querySelector('.icon-project');
  

  }
  
  selectedWord: { [key: string]: string | null } = {};
  
  hasChangesInCategory(category: string): boolean {
  return this.cambios_de_palabras.some(cambio => cambio.origen === category.toUpperCase());
}


  selectWord(category: string, word: string): void {
    
     // Si ya hay otra categoría seleccionada y no es la actual, no hacer nada
    const categoriaActiva = Object.keys(this.selectedWord).find(cat => this.selectedWord[cat] !== null);
    if (categoriaActiva && categoriaActiva !== category) {
      // Solo bloquear si esa categoría tiene cambios sin actualizar
      if (this.hasChangesInCategory(categoriaActiva)) {
        this.proyectoService.updateEditCategory(true);
      //   console.log(
      //   "Cambios actuales:",
      //   this.cambios_de_palabras.map(c => 
      //     `Palabra: "${c.palabra}" | Categoría: ${c.origen} | Nuevo nivel: ${c.new_level}`
      //   )
      // );
      
      // const cambiosLista = this.cambios_de_palabras.map(c => 
      //   `"${c.palabra}" | Categoría: ${c.origen} | Nuevo nivel: ${c.new_level}`
      // ).join('\n');

      // this.proyectoService.updateValueEditCategory(cambiosLista);


        return; // Bloquea hasta que hagan reset o update
      }
    }

    // Resetear todas las selecciones en otras categorías
    for (const cat in this.selectedWord) {
        if (cat !== category) {
            this.selectedWord[cat] = null;
        }
    }

    // Seleccionar la nueva palabra en la categoría actual
    this.selectedWord[category] = word;

    // Obtener la descripción de la palabra seleccionada
    // const descripcion = this.data_pof2[category.toUpperCase()][word];
    this.fachada.getLexicalEVPOfWords(this.http, this.currentEnglishType, word)
            .then(respuesta => {
              this.respuestaWords = respuesta;
            })
            .catch(error => {
              console.log("Error en la petición regresamos array básico");
              this.respuestaWords = [
                {
                  "id": 1,
                  "nivel": "A1",
                  "palabra": word,
                  "tipo": "Unlisted",
                  "descripcion": "Unlisted",
                  "current": false
                },
                {
                  "id": 2,
                  "nivel": "A2",
                  "palabra": word,
                  "tipo": "Unlisted",
                  "descripcion": "Unlisted",
                  "current": false
                },
                {
                  "id": 3,
                  "nivel": "B1",
                  "palabra": word,
                  "tipo": "Unlisted",
                  "descripcion": "Unlisted",
                  "current": false
                },
                {
                  "id": 4,
                  "nivel": "B2",
                  "palabra": word,
                  "tipo": "Unlisted",
                  "descripcion": "Unlisted",
                  "current": false
                },
                {
                  "id": 5,
                  "nivel": "C1",
                  "palabra": word,
                  "tipo": "Unlisted",
                  "descripcion": "Unlisted",
                  "current": false
                },
                {
                  "id": 6,
                  "nivel": "C2",
                  "palabra": word,
                  "tipo": "Unlisted",
                  "descripcion": "Unlisted",
                  "current": false
                },
              ]
            });
  }
  
  isWordSelected(data: any, position: number, actual: any) {
    actual.descripcion = actual.descripcion.replace('"',"")
    let temporal = this.data_pof2[data.toUpperCase()][this.selectedWord[data]][position]
    return ((actual.nivel == data.toUpperCase()) && (actual.descripcion == temporal))
  }

  async onSelectionRadioChange(selectedItem: any, position, origen) {

    let data = {
      "palabra": selectedItem.palabra,
      "new_level": selectedItem.nivel,
      "description": selectedItem.descripcion,
      "position": position,
      "origen": origen
    }
    let editado = false
    for (let index = 0; index < this.cambios_de_palabras.length; index++) {
      if (this.cambios_de_palabras[index].position == data.position) {
        editado = true;
        this.cambios_de_palabras[index] = data;
        break;
      }
    }
    
    if (!editado){
      this.cambios_de_palabras.push(data)
    }
    this.proyectoService.undoMarcadoMultiple(this.http);
    // console.log(data);
  }
  
async resetCategoryView(category: string) {
  // Quitar selección de palabra en esa categoría
  this.selectedWord[category] = null;

  // Limpiar los cambios relacionados con esa categoría
  this.cambios_de_palabras = this.cambios_de_palabras.filter(c => c.origen !== category.toUpperCase());

  // Limpiar los radios/estados de selección de esa categoría
  Object.keys(this.palabraSeleccionada).forEach(key => {
    if (key.startsWith(category.toUpperCase() + "-")) {
      this.palabraSeleccionada[key] = false;
    }
  });

  // Resetear respuestaWords para que se vacíe la tabla
  this.respuestaWords = [];

}


  async updateCategory(category: string) {
  // Si no hay cambios en la selección, no hacemos nada
  if (this.cambios_de_palabras.length === 0) {

    this.selectedWord[category] = null;
  } else {
    this.UpdateEVP = true;
    this.selectedWord[category] = null; // Resetea la selección para mostrar la lista completa
    
    await this.cambios_de_palabras.sort((a, b) => a.position - b.position);
    
    let data = {
      "palabras": this.cambios_de_palabras
    };
    
    
    await this.fachada.UpdateEVPWordCategory(this.http, sessionStorage.getItem('text_UID'), data);
    
    this.cambios_de_palabras = [];
    this.initEVP();
    setTimeout(() => {
      this.proyectoService.undoMarcadoMultiple(this.http);
      this.seeAllIconSrc = '../../assets/images/eye-icon.svg';
      Object.keys(this.isEyeOn).forEach(categoria => {
        this.isEyeOn[categoria] = false;
      });
      Object.keys(this.palabraresaltada).forEach(categoria => {
        Object.keys(this.palabraresaltada[categoria]).forEach(palabraResaltada => {
          this.palabraresaltada[categoria][palabraResaltada] = false;
        });
        Object.keys(this.palabraSeleccionada).forEach(key => {
          this.palabraSeleccionada[key] = false;
        });
      });
    }, 1000);
  }
}

  transform(value: number): string {
    //No queria usar pipes así que se lo pedi a chatGTP ///>.<///
    if (!value) return '';

    const suffixes = ['th', 'st', 'nd', 'rd'];
    const v = value % 100;

    // Si el número termina en 11, 12 o 13, siempre usa "th"
    if (v >= 11 && v <= 13) {
      return `${value}th`;
    }

    // De lo contrario, usa los sufijos correctos para 1, 2 y 3; el resto usa "th"
    const lastDigit = value % 10;
    const suffix = suffixes[lastDigit] || 'th';

    return `${value}${suffix}`;
  }

  //PRUEBA 9
isEyeOn: { [key: string]: boolean } = {};
categoriasActivas: Set<string> = new Set();

toggleEyeIcon(data: string): void {
  const categoriaUpper = data.toUpperCase();

  if (!this.data_pof3[categoriaUpper]) {
    console.error(`No se encontró la categoría "${categoriaUpper}".`);
    return;
  }
  // Apagar todos los ojos de verPalabra
  Object.keys(this.palabraSeleccionada).forEach(key => {
    this.palabraSeleccionada[key] = false;
  });

  const estadoActual = this.isEyeOn[categoriaUpper] || false;

  if (estadoActual) {
    this.categoriasActivas.delete(categoriaUpper);
    this.isEyeOn[categoriaUpper] = false;

    // Si "See All" estaba activo y desactivamos una categoría, apagamos solo el botón sin resetear todo
    if (this.seeAllActive) {
      this.seeAllActive = false;
    }

    // Si era la única categoría activa, llamar `undoMarcadoMultiple()`
    if (this.categoriasActivas.size === 0) {
      this.proyectoService.undoMarcadoMultiple(this.http);
    } else {
      this.actualizarResaltadoTexto();
    }
  } else {
    this.categoriasActivas.add(categoriaUpper);
    this.isEyeOn[categoriaUpper] = true;

    // **Apagar todos los ojos de las palabras**
    Object.keys(this.palabraresaltada).forEach(categoria => {
      Object.keys(this.palabraresaltada[categoria]).forEach(palabra => {
        this.palabraresaltada[categoria][palabra] = false;
      });
    });

    this.actualizarResaltadoTexto();
  }

  // Solo activar "See All" si todas las categorías están prendidas
  const allOn = Object.keys(this.data_pof3).every(categoria => this.isEyeOn[categoria]);
  this.seeAllActive = allOn;
  this.seeAllIconSrc = allOn
      ? '../../assets/images/yellow_icons/eye-on-icon.svg'
      : '../../assets/images/eye-icon.svg';
}


// Método para actualizar el resaltado en el texto considerando solo las categorías activas
actualizarResaltadoTexto(): void {
  let posicionesGlobales: { categoria: string; palabra: string; posicion: number }[] = [];

  // Recorrer todas las categorías disponibles para capturar todas las coincidencias
  Object.keys(this.data_pof3).forEach(categoria => {
      Object.keys(this.data_pof3[categoria]).forEach(palabra => {
          this.data_pof3[categoria][palabra].forEach(posicion => {
              posicionesGlobales.push({ categoria, palabra, posicion });
          });
      });
  });

  // Ordenar todas las posiciones de acuerdo con su aparición en el texto
  posicionesGlobales.sort((a, b) => a.posicion - b.posicion);

  // Mapear palabras con su posición y la categoría más relevante
  let posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] } = {};

  posicionesGlobales.forEach(({ categoria, palabra, posicion }) => {
      if (!posicionesPorPalabra[palabra]) {
          posicionesPorPalabra[palabra] = [];
      }
      posicionesPorPalabra[palabra].push({ posicion, categoria });
  });

  // Condición para manejar una categoría seleccionada vs. múltiples categorías activas
  if (this.categoriasActivas.size === 1) {
      // Caso de una sola categoría activa: aplicar lógica específica
      const categoriaUnica = [...this.categoriasActivas][0];

      this.proyectoService.resaltarMultiplesCoincidenciasCategoria(
          Object.keys(this.data_pof3[categoriaUnica]),
          categoriaUnica,
          posicionesPorPalabra,
          this.http
      );
  } else {
      // Caso de múltiples categorías activas: aplicar resaltado estándar
      let posicionesFiltradas: { [key: string]: { posicion: number; categoria: string }[] } = {};

      // Filtrar posiciones por categorías activas y ordenar por posición
      Object.keys(posicionesPorPalabra).forEach(palabra => {
          // Filtrar solo las posiciones de las categorías activas
          posicionesFiltradas[palabra] = posicionesPorPalabra[palabra]
              .filter(({ categoria }) => this.categoriasActivas.has(categoria))
              // Ordenar las posiciones por su valor 'posicion'
              .sort((a, b) => a.posicion - b.posicion);
      });

      this.proyectoService.aplicarResaltado(posicionesFiltradas,this.http);
  }
}



seeAllHighlighted: boolean = false; // Controla el estado del botón "See All"
seeAllIconSrc: string = '../../assets/images/eye-icon.svg'; // Controla el ícono del botón "See All"
  

toggleEyeIconPalabra(data: string, palabra: string): void {
  const categoriaUpper = data.toUpperCase();

  if (!this.data_pof3[categoriaUpper] || !this.data_pof3[categoriaUpper][palabra]) {
    console.error(`No se encontró la palabra "${palabra}" en la categoría "${categoriaUpper}".`);
    return;
  }

  const estadoActual = this.palabraresaltada[categoriaUpper]?.[palabra];

  if (estadoActual) {
    this.palabraresaltada[categoriaUpper][palabra] = false;
    this.proyectoService.undoMarcado([palabra], categoriaUpper);
    return;
  }

  // **Apagar todas las palabras resaltadas en TODAS las categorías antes de activar la nueva**
  Object.keys(this.palabraresaltada).forEach(categoria => {
    Object.keys(this.palabraresaltada[categoria]).forEach(palabraResaltada => {
      this.palabraresaltada[categoria][palabraResaltada] = false;
    });
  });

  Object.keys(this.palabraresaltada[categoriaUpper] || {}).forEach(key => {
    this.palabraresaltada[categoriaUpper][key] = false;
  });

  // **Apagar todos los ojos visibles**
  Object.keys(this.isEyeOn).forEach(categoria => {
    this.isEyeOn[categoria] = false;
  });
  this.categoriasActivas.clear();
  this.seeAllActive = false;
  this.seeAllIconSrc = '../../assets/images/eye-icon.svg';

  // **También asegurarse de que las imágenes de los ojos se actualicen correctamente en palabraSeleccionada**
  Object.keys(this.palabraSeleccionada).forEach(key => {
    this.palabraSeleccionada[key] = false;
  });

  // **Organizar posiciones globalmente sin alterar resaltarMultiplesCoincidencias**
  let posicionesGlobales: { categoria: string; palabra: string; posicion: number }[] = [];

  Object.keys(this.data_pof3).forEach(categoria => {
    Object.keys(this.data_pof3[categoria]).forEach(palabra => {
      this.data_pof3[categoria][palabra].forEach(posicion => {
        posicionesGlobales.push({ categoria, palabra, posicion });
      });
    });
  });


  posicionesGlobales.sort((a, b) => a.posicion - b.posicion);

  let posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] } = {};
  
  posicionesGlobales.forEach(({ categoria, palabra, posicion }) => {
    if (!posicionesPorPalabra[palabra]) {
      posicionesPorPalabra[palabra] = [];
    }
    posicionesPorPalabra[palabra].push({ posicion, categoria });
  });


  this.palabraresaltada[categoriaUpper][palabra] = true;

  // **Enviar datos a proyectoService sin alterar su lógica**
  this.proyectoService.resaltarMultiplesCoincidencias([palabra], categoriaUpper, posicionesPorPalabra,this.http);

}


seeAllActive: boolean = false;
toggleSeeAll(): void {
  const allOn = !this.seeAllActive; // Invertir el estado actual

// Apagar todas las palabras resaltadas
Object.keys(this.palabraresaltada).forEach(categoria => {
  Object.keys(this.palabraresaltada[categoria]).forEach(palabra => {
      this.palabraresaltada[categoria][palabra] = false;
  });
});

// Apagar todos los ojos de verPalabra
Object.keys(this.palabraSeleccionada).forEach(key => {
  this.palabraSeleccionada[key] = false;
});


  
  // **Actualizar el estado de cada categoría correctamente**
  Object.keys(this.data_pof3).forEach(categoria => {
      this.isEyeOn[categoria] = allOn;
      if (allOn) {
          this.categoriasActivas.add(categoria);
      } else {
          this.categoriasActivas.delete(categoria);
      }

  });

  // Actualizar el estado del botón "See All"
  this.seeAllActive = allOn;
  this.seeAllIconSrc = allOn
      ? '../../assets/images/yellow_icons/eye-on-icon.svg'
      : '../../assets/images/eye-icon.svg';

  if (allOn) {
      // Resaltar todas las categorías
      let posicionesGlobales: { categoria: string; palabra: string; posicion: number }[] = [];

      Object.keys(this.data_pof3).forEach(categoria => {
          Object.keys(this.data_pof3[categoria]).forEach(palabra => {
              this.data_pof3[categoria][palabra].forEach(posicion => {
                  posicionesGlobales.push({ categoria, palabra, posicion });
              });
          });
      });

      posicionesGlobales.sort((a, b) => a.posicion - b.posicion);

      let posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] } = {};

      posicionesGlobales.forEach(({ categoria, palabra, posicion }) => {
          if (!posicionesPorPalabra[palabra]) {
              posicionesPorPalabra[palabra] = [];
          }
          posicionesPorPalabra[palabra].push({ posicion, categoria });
      });

      this.proyectoService.resaltarTodasLasCategorias(posicionesPorPalabra,this.http);
  } else {
      // Solo ejecutar `undoMarcadoMultiple()` cuando "See All" estaba activado y ahora se apaga
      this.proyectoService.undoMarcadoMultiple(this.http);
  }
}


  

  export_detallado(){
    let respaldo_ID = document.getElementById("PROJECT_ID_RESPALDO") as HTMLInputElement
    if(respaldo_ID){
      if (respaldo_ID.value != '' && respaldo_ID.value != null){
        this.fachada.detail_export("lexical-evp", respaldo_ID.value)
      }else{
        alert("No hay proyecto cargado")
      }
    }else{
      alert("No esta en la página principal")
    }
  }

  export_tagger(){
    let respaldo_ID = document.getElementById("PROJECT_ID_RESPALDO") as HTMLInputElement
    if(respaldo_ID){
      if (respaldo_ID.value != '' && respaldo_ID.value != null){
        this.fachada.tagger_export("lexical-evp", respaldo_ID.value)
      }else{
        alert("No hay proyecto cargado")
      }
    }else{
      alert("No esta en la página principal")
    }
  }

  isButtonDisabled(): boolean {
    return !sessionStorage.getItem("text_UID"); 
  }

}
